import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Card } from "antd";
import { useI18n, useTemplateCenter } from "../../contexts";
import { COOKIE_EXPERTS_LOGO_URL, useCookieExpertsModal } from "../../hooks";
const { Meta } = Card;
const TemplateCenterHeader = (param)=>{
    let { onSelect } = param;
    const { __ } = useI18n();
    const { quickLinks } = useTemplateCenter();
    const { openDialog: openCookieExperts } = useCookieExpertsModal();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: quickLinks.map((link)=>{
            if (typeof link === "string") {
                switch(link){
                    case "cookie-experts":
                        return {
                            id: "cookie-experts",
                            cover: /*#__PURE__*/ _jsx("img", {
                                src: COOKIE_EXPERTS_LOGO_URL,
                                style: {
                                    display: "block",
                                    paddingTop: 15,
                                    margin: "auto",
                                    height: 81
                                }
                            }),
                            title: "Cookie Experts",
                            description: __("help you with the setup"),
                            onClick: openCookieExperts
                        };
                    case "service-individual":
                        return {
                            id: "from-scratch",
                            cover: /*#__PURE__*/ _jsx(PlusOutlined, {
                                style: {
                                    paddingTop: 25,
                                    fontSize: 70
                                }
                            }),
                            title: __("Create from scratch"),
                            description: __("an individual service"),
                            onClick: ()=>onSelect(undefined)
                        };
                    case "blocker-individual":
                        return {
                            id: "from-scratch",
                            cover: /*#__PURE__*/ _jsx(PlusOutlined, {
                                style: {
                                    paddingTop: 25,
                                    fontSize: 70
                                }
                            }),
                            title: __("Create from scratch"),
                            description: __("an individual content blocker"),
                            onClick: ()=>onSelect(undefined)
                        };
                    case "service-scanner":
                        return {
                            id: "scanner",
                            cover: /*#__PURE__*/ _jsx(SearchOutlined, {
                                style: {
                                    paddingTop: 25,
                                    fontSize: 70
                                }
                            }),
                            title: __("Scan website"),
                            description: __("and find used service"),
                            onClick: ()=>window.location.hash = "#/scanner"
                        };
                    default:
                        break;
                }
            }
            return link;
        }).map((param)=>{
            let { id, cover, description, onClick, title } = param;
            return /*#__PURE__*/ _jsx(Card, {
                hoverable: true,
                style: {
                    margin: 5,
                    width: 240,
                    display: "inline-block"
                },
                onClick: onClick,
                cover: cover,
                children: /*#__PURE__*/ _jsx(Meta, {
                    title: title,
                    description: description
                })
            }, id);
        })
    });
};
export { TemplateCenterHeader };
